import { COLORS } from '../IndividualPlan/tokens';

export const REPORTS = {
  ink: COLORS.ink,
  muted: COLORS.muted,
  surface: COLORS.bg,
  cardBg: '#FFFFFF',
  chip: { bg: '#E3E3E8', fg: '#7F7F99' },
  cover: { bg: '#D4D4F2' },
  action: COLORS.navy,
  error: '#B20101',
  welcome: {
    bg: '#EFEFFA',
    chipBg: '#D4D4F2',
    chipFg: '#151547',
    dismiss: 'rgba(8, 8, 27, 0.54)',
  },
  cardShadow:
    '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
} as const;
